module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image5c"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "327",
      "src": "images/6.jpg",
      "width": "300"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Budgeting allows you to control your money rather than money controlling you. The goal of budgeting is to spend "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("less")]), _vm._v(" money than you make and to decide in advance where your money is going.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Basic budget worksheet")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Monthly income: ____________")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_vm._v("Monthly expenses")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Fixed expenses (expenses that stay the same every month)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tithe/charitable giving ____________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Utilities ____________")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Insurance ____________")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Car loan ____________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Student loans ____________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Phone bill ____________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Internet service ____________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other payments ____________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Tot")]), _vm._v("al fi"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("xed expenses ____________")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A. Monthly income __________ – Fixed expenses __________ = The amount you can spend on your variable expenses __________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Variable expenses (expenses the amounts of which can change from month to month)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Groceries ___________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Household items (stamps, light bulbs, plants, etc.) _____________")]), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Personal items (toiletries, dry cleaning, haircuts, etc.) __________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transportation (gas, parking, bus pass, auto maintenance, etc.)"), _c('br'), _vm._v("__________________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clothing ___________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Savings ___________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Entertainment (cable, movies, eating out) ___________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Other _____________________________________________")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Total variable expenses _______________________________")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("B. Amount from Line A ____________ – Total variable expenses____________ = ____________")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  })]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "sidebartit"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Budgeting resources")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "indenthanging"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("• Dave Ramsey, money management expert (")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.daveramsey.com",
      "target": "_blank"
    }
  }, [_vm._v("www.daveramsey.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("• Crown Financial Ministries ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.crown.com",
      "target": "_blank"
    }
  }, [_vm._v("www.crown.org")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Take your total variable expenses and subtract them from total on line A. The answer must be greater than zero! If the answer is a negative number, reduce your budgeted numbers, starting with the variable expenses first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("WARNING—Do not adjust groceries and clothing to zero. You have to eat and have clothes on your back . . . you just don’t have to eat sushi and wear designer clothing.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7249d7aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 93
// module chunks = 0